export const getDayString = (
  day: number
): "sun" | "mon" | "tue" | "wed" | "thu" | "fri" | "sat" => {
  switch (day) {
    case 0:
      return "sun";
    case 1:
      return "mon";
    case 2:
      return "tue";
    case 3:
      return "wed";
    case 4:
      return "thu";
    case 5:
      return "fri";
    case 6:
      return "sat";
    default:
      return "sun";
  }
};

export const getTimeFromString = (str: string): Date => {
  try {
    const parts = str.split(":");
    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    return date;
  } catch (e) {
    return new Date();
  }
};

export const minutesToString = (minutes: number) => {
  if (minutes < 10) {
    return "0" + minutes;
  } else {
    return minutes + "";
  }
};
